import { useCallback, useEffect, useState } from 'react'

import { API } from '@enkla-gui'

export const useGet = ({ endpoint, params = null, filter: _filter = {}, enabled = true, onSuccess }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(null)
  const [error, setError] = useState(null)
  const [sorting, setSorting] = useState({})
  const [filter, setFilter] = useState(_filter)
  const [page, setPage] = useState(0)

  const updateFilter = useCallback(f => {
    setFilter(f)
    setPage(0)
  }, [])

  const updateSorting = useCallback(s => {
    setSorting(s)
    setPage(0)
  }, [])

  const get = useCallback(() => {
    setLoading(true)
    API.get(endpoint, { ...params, ...filter, ...sorting, page: page })
      .then(res => {
        setData(res)
        setLoading(false)
        onSuccess?.(res)
      })
      .catch(err => {
        setError(err)
        setLoading(false)
      })
  }, [endpoint, params, sorting, filter, page])

  useEffect(() => {
    if (enabled) {
      get()
    }
  }, [get, enabled])

  return { data, loading, error, fetch: get, setPage, setSorting: updateSorting, setFilter: updateFilter, sorting, getFilter: filter }
}
